import { useMemo } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { jwtDecode } from 'jwt-decode';
import _ from 'lodash';

const getBrowserTimeZone = (): string | null => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};

/**
 * IANA time zone of the logged-in user from their profile (JWT
 * `otto_identity.timezone`, e.g. "Europe/Berlin"). Falls back to the browser's
 * time zone when there is no token, decoding fails or the claim is missing.
 * Unlike the region or client, it is set for global admins too.
 */
export const useUserTimeZone = (): string | null => {
  const { keycloak } = useKeycloak();
  return useMemo<string | null>(() => {
    if (!keycloak.token) return getBrowserTimeZone();
    try {
      const decoded = jwtDecode<Record<string, unknown>>(keycloak.token);
      const value = _.get(decoded, 'otto_identity.timezone', null);
      return typeof value === 'string' && value ? value : getBrowserTimeZone();
    } catch {
      return getBrowserTimeZone();
    }
  }, [keycloak.token]);
};
